import { mapDTO } from '@twistezo/ts-dto-mapper'

import { JSON_SPACE } from 'constants/json'
import { DomainPrebidStack } from '../../types/domainPrebidStack'
import { DomainPrebidStackDTO } from '../types/domainPrebidStackDTO'

export const domainPrebidStackFromDTO = (from: DomainPrebidStackDTO): DomainPrebidStack =>
  mapDTO<DomainPrebidStackDTO, DomainPrebidStack>({ from }).transform(
    (domainPrebidStackDTO: DomainPrebidStackDTO): DomainPrebidStack => {
      const {
        allowActivitiesData,
        createdAt,
        domainAmazonEnabled,
        prebidCustomConfig,
        updatedAt,
        ...rest
      } = domainPrebidStackDTO

      return {
        ...rest,
        allowActivitiesData: allowActivitiesData ?? '',
        createdAt: new Date(createdAt),
        domainAmazonEnabled: domainAmazonEnabled ?? undefined,
        prebidCustomConfig: JSON.stringify(prebidCustomConfig, null, JSON_SPACE),
        updatedAt: new Date(updatedAt),
      }
    },
  )
